import React from "react";
import { Link } from "react-router-dom";
import PostItem from "./PostItem";
import { PostSkeletons } from "./Loader";

const PostGrid = ({ posts, isLoading, emptyTitle = "No posts yet", emptyText }) => {
  if (isLoading) return <PostSkeletons />;

  if (!posts.length) {
    return (
      <div className="empty">
        <h3>{emptyTitle}</h3>
        <p>{emptyText || "Be the first to share something useful."}</p>
        <Link to="/create" className="btn btn--primary">
          Write a post
        </Link>
      </div>
    );
  }

  return (
    <div className="post-grid">
      {posts.map(({ _id, thumbnail, category, title, description, creator, createdAt }, i) => (
        <PostItem
          key={_id}
          index={i}
          postID={_id}
          thumbnail={thumbnail}
          category={category}
          title={title}
          description={description}
          authorID={creator}
          createdAt={createdAt}
        />
      ))}
    </div>
  );
};

export default PostGrid;
